import React, { useContext, useState } from 'react'
import { MetaContext, MetaContextPayload } from '../../../context/metaContext';
import { useNavigate } from 'react-router-dom';
import { deleteMetaIntegrationPayload } from '../../../models/axiosModel';
import { IntegrationContext, IntegrationContextPayload } from '../../../context/integrationContext';
import FacebookInformationCard from '../../utility/facebookInformationCard';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import { Grid, useMediaQuery } from '@mui/material';
import GlobalPopUp from '../../utility/globalPopUp';
import DeployChatbotDialog from './deployChatbotDialog';
import globalStyles from "../../../assets/styles/global.module.scss";
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
// import FacebookInformationCard from '../../utils/FacebookInformationCard';

interface checkFlag {
    flagPage?: boolean
}

function InstagramIntegationDetails(props: checkFlag) {
    const navigate = useNavigate()
    const { facebookIntegrationDetails, getMetaIntegrationList, integrationListNewStructure, globalIntegrationTypeList } = useContext(IntegrationContext) as IntegrationContextPayload
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const { setGetChatbotIntegrationData, GetChatbotIntegrationData } = useContext(MetaContext) as MetaContextPayload;
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);

    const [flagDialogShowAllChatBot, setFlagDialogShowAllChatBot] = useState<boolean>(false);
    const [showConfirmationPopover, setShowConfirmationPopover] = useState<boolean>(false);
    const [confirmationPopoverAnchorEl, setConfirmationPopoverAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [flagUnDeployConfirmation, setFlagUnDeployConfirmation] = useState<boolean>(false);

    const [flagIntegrationSuccessful, setFlagIntegrationSuccessful] = useState<boolean>(false);
    const [chatbotId, setChatbotId] = useState<string>("");

    const smallScreen = useMediaQuery('(max-width : 900px) and (min-width : 0px)')
    
    const linkedAiChatbot = facebookIntegrationDetails?.chatbot_integration_assignment_data?.find((chatbot) => !chatbot.is_workflow_chatbot)

    const deleteMetaIntegration = async () => { 
        if(facebookIntegrationDetails){
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            let response: any
            let payload: deleteMetaIntegrationPayload = {
                channel_id: facebookIntegrationDetails.channel_id,
                integrated_channel_id: facebookIntegrationDetails.integrated_channel_id
            }
            response = await agent.deleteMetaIntegration.delete(payload)
            if (response.status) {
                showSuccess("Integration deleted Successfully!")
                navigate('/channels')
            } else {
                handleError(response);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        }
    }

    const onClickOfDeployBtn = () => {
        setFlagDialogShowAllChatBot(true);
    }

    const handleCloseConfirmationPopover = () => {
        setConfirmationPopoverAnchorEl(null);
        setShowConfirmationPopover(false)
    };

    const onDeployClick = async (chatbot_id: string) => {
        if (facebookIntegrationDetails !== null) {
            handleCloseConfirmationPopover();
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
            const payload = {
                // instagram_id: facebookIntegrationDetails.meta_integration_facebook_data.instagram_id,
                // meta_integration_type_id: facebookIntegrationDetails.meta_integration_type_assignment_data.meta_integration_type_id.toString(),
                chatbot_id: chatbot_id,
                // integrated_channel_id: facebookIntegrationDetails.integrated_channel_id,
                // integrated_channel_id: facebookIntegrationDetails.meta_integration_facebook_data.integrated_channel_id,
                integrated_channel_id: String(facebookIntegrationDetails.integrated_channel_id),
                // page_id: facebookIntegrationDetails.meta_integration_facebook_data.page_id,
                // meta_integration_id: facebookIntegrationDetails.meta_integration_id.toString(),
            }

            const res = await agent.addChatbotIntegration.post(payload);
            if (res.status) {
                setFlagDialogShowAllChatBot(false);
                showSuccess("Integration Successfull!")
                setChatbotId(chatbot_id);
                setFlagIntegrationSuccessful(true);
                setGetChatbotIntegrationData(res.data);
                getMetaIntegrationList();
            } else {
                handleError(res);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
        }
    }

    const removeChatbotIntegration = () => {
        if (integrationListNewStructure) {
            setFlagUnDeployConfirmation(true);
        }
    }

    const deleteChatbotIntegration = async () => {
        if (facebookIntegrationDetails !== null) {

            const chatbot_id = String(linkedAiChatbot?.chatbot_id ?? linkedAiChatbot?.ai_chatbot_id ?? "")
            if (!chatbot_id) {
                return
            }

            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
            let channel_id = globalIntegrationTypeList?.find((channel) => channel?.channel_name?.toLowerCase() == 'instagram')?.channel_id.toString() || ''
            
            const res = await agent.removeChatbotIntegration.delete(
                channel_id,
                chatbot_id,
                String(facebookIntegrationDetails.integrated_channel_id)
                // facebookIntegrationDetails?.meta_integration_id,
                // facebookIntegrationDetails?.meta_integration_type_assignment_data?.meta_integration_type_id,
                // facebookIntegrationDetails?.meta_integration_facebook_data.instagram_id,
            );
            
            if (res.status) {
                showSuccess("Integration Removed Successfully")
                const response = await GetChatbotIntegrationData(chatbot_id, "")
                if(!(response.status)){
                    handleError(response);
                }
                getMetaIntegrationList()
            } else {
                handleError(res);
            }
            setFlagUnDeployConfirmation(false);
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
        }
    }

    return (
        <>
            {facebookIntegrationDetails !== null &&
                <>
                    {/* Meta */}
                    <FacebookInformationCard
                        integrationType='Instagram'
                        // key={facebookIntegrationDetails?.meta_integration_facebook_data?.meta_integration_facebook_id}
                        key={facebookIntegrationDetails.integrated_channel_id}
                        flagDelete={true}
                        title={"Meta"}
                        flagShowMetaIcon={true}
                        currentlySelected={false}
                        details={{
                            // page_id: facebookIntegrationDetails?.meta_integration_facebook_data?.page_id,
                            integrated_channel_id: String(facebookIntegrationDetails.integrated_channel_id)
                        }}
                        deleteChatbotIntegration={() => setShowDeleteConfirmation(true)}
                    />

                    {/* Connected Account */}
                    <FacebookInformationCard
                        integrationType='Instagram'
                        key={1}
                        flagDelete={false}
                        title={`Facebook Account ${1}`}
                        // currentlySelected={facebookIntegrationDetails?.meta_integration_facebook_data?.chatbot_integration_assignment_data.length > 0}
                        currentlySelected={facebookIntegrationDetails.chatbot_integration_assignment_data.length > 0}
                        details={{
                            // page_id: facebookIntegrationDetails?.meta_integration_facebook_data?.instagram_id,
                            // integrated_channel_id: facebookIntegrationDetails?.meta_integration_facebook_data?.integrated_channel_id,
                            // page_name: facebookIntegrationDetails?.meta_integration_facebook_data?.instagram_username,
                            // page_category: facebookIntegrationDetails?.meta_integration_facebook_data?.page_category,
                            // linked_chatbots: facebookIntegrationDetails?.meta_integration_facebook_data?.chatbot_integration_assignment_data

                            page_id: "instagram_account_id" in facebookIntegrationDetails ? facebookIntegrationDetails.instagram_account_id : "",
                            integrated_channel_id: String(facebookIntegrationDetails.integrated_channel_id),
                            page_name: "instagram_account_name" in facebookIntegrationDetails ? facebookIntegrationDetails.instagram_account_name : "",
                            page_category: "instagram_account_category" in facebookIntegrationDetails ? facebookIntegrationDetails.instagram_account_category : "",
                            linked_chatbots: facebookIntegrationDetails.chatbot_integration_assignment_data?.filter((chatbot) => !(chatbot.is_workflow_chatbot)), 
                            linked_workflows: facebookIntegrationDetails.chatbot_integration_assignment_data?.filter((chatbot) => chatbot.is_workflow_chatbot)
                        }}
                        flagChatbotDeploy={true}
                        addChatbotIntegration={onClickOfDeployBtn}
                        removeChatbotIntegration={(page_id, integrated_channel_id) => removeChatbotIntegration()}
                    />
                </>
            }

            {showDeleteConfirmation &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete this Integration`}
                    open={showDeleteConfirmation}
                    onClose={() => { setShowDeleteConfirmation(false) }}
                    onDelete={() => {
                        deleteMetaIntegration()
                        setShowDeleteConfirmation(false)
                    }}
                />
            }

            {flagDialogShowAllChatBot &&
                <GlobalPopUp
                    open={flagDialogShowAllChatBot}
                    onClose={() => setFlagDialogShowAllChatBot(false)}
                    handleClose={() => setFlagDialogShowAllChatBot(false)}
                    flagShowCloseIcon={true}
                    paperMinWidth={smallScreen ? '85%' : '90vw'}
                    height='90vh'
                    title='Link Chatbot'
                >
                    <DeployChatbotDialog
                        // pageName={facebookIntegrationDetails?.meta_integration_facebook_data?.instagram_username}
                        pageName={(facebookIntegrationDetails && "instagram_account_name" in facebookIntegrationDetails) ? facebookIntegrationDetails.instagram_account_name : ""}
                        showConfirmationPopover={showConfirmationPopover}
                        setShowConfirmationPopover={setShowConfirmationPopover}
                        confirmationPopoverAnchorEl={confirmationPopoverAnchorEl}
                        setConfirmationPopoverAnchorEl={setConfirmationPopoverAnchorEl}
                        handleCloseConfirmationPopover={handleCloseConfirmationPopover}
                        onDeployClick={(chatbot_id) => { onDeployClick(chatbot_id) }}
                    />
                </GlobalPopUp>
            }

            {flagIntegrationSuccessful &&
                <GlobalPopUp
                    open={flagIntegrationSuccessful}
                    flagShowCloseIcon
                    backgroundColor={"#40813F"}
                    title={"Congratulations!"}
                    handleClose={() => { setFlagIntegrationSuccessful(false) }}
                >
                    <Grid container className={globalStyles.congratulationsWrapper} >
                        <Grid item className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`} >
                            The AI chatbot has been successfully deployed on this Instagram page!
                        </Grid>
                        <Grid item className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}> you can now head to your instagram account and start chatting with the instagram page.</Grid>
                        <Grid item className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>You can also track your chats <a href={`/inbox`}>here</a> in the inbox</Grid>
                    </Grid>
                </GlobalPopUp>
            }

            {flagUnDeployConfirmation &&
                <GlobalPopUp
                    open={flagUnDeployConfirmation}
                    handleClose={() => { setFlagUnDeployConfirmation(false) }}
                >
                    <GlobalDeletePopup
                        // deleteDescription={`Are you sure you want to delete ${facebookIntegrationDetails?.meta_integration_facebook_data?.chatbot_integration_assignment_data[0].chatbot_name || ""} from ${facebookIntegrationDetails?.meta_integration_facebook_data?.instagram_username || ""}`}
                        deleteDescription={`Are you sure you want to delete ${linkedAiChatbot?.chatbot_name || ""} from ${ (facebookIntegrationDetails && "instagram_account_name" in facebookIntegrationDetails) ? facebookIntegrationDetails?.instagram_account_name : ""}`}
                        onClose={() => { setFlagUnDeployConfirmation(false) }}
                        onDelete={() => { deleteChatbotIntegration() }}
                    />
                </GlobalPopUp>
            }

        </>

    )
}

export default InstagramIntegationDetails